import { render, staticRenderFns } from "./BaseTLImage.vue?vue&type=template&id=08418ef4&"
import script from "./BaseTLImage.vue?vue&type=script&lang=ts&"
export * from "./BaseTLImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports